
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = []
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "5d08d25751f821b2423f.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			